<template>
  <div v-if="isSupport" class="menu">
    <li class="list-group-item" v-on:click="isMenuOpened = !isMenuOpened">
      <img class="menu-logo" :src="app_root + '/assets/common/img/printlink/apri.svg'" alt="app_print" align="middle">
      <LabelFunMessage fcontId="0" msgkey="121" />
      <span
        v-if="!isMenuOpened"
        class="glyphicon glyphicon-chevron-down"
        aria-hidden="true"
      ></span>
      <span
        v-if="isMenuOpened"
        class="glyphicon glyphicon-chevron-up"
        aria-hidden="true"
      >
      </span>
    </li>

    <collapse v-model="isMenuOpened" class="app-menu">
      <div class="app-menu-inner">
        <p class="app-message">
          <LabelFunMessage fcontId="0" msgkey="130" />
        </p>
        <p class="text-center">
          <AppCompatiblePrinters appName="creative" />
        </p>
        <div class="app_info">
          <img :src="app_root + '/assets/common/img/printlink/creativeprint.png'" />
          <p class="app_title">
            <LabelFunMessage fcontId="0" msgkey="27" />
          </p>
        </div>

        <!-- 記事内に表示するアプリ起動ボタン・インストールボタン -->
        <div>
          <p class="text-center">
            <a v-on:click="launchApp()" class="btn btn-info btn-lg" role="button">
              <LabelFunMessage fcontId="0" msgkey="30" />&nbsp;&raquo;
            </a>
          </p>

          <!-- <p>
            <span class="how_point">
              <span class="glyphicon glyphicon-info-sign"></span>
              <LabelFunMessage fcontId="0" msgkey="31" />
            </span>
          </p> -->
          <!-- iOS9以降でセキュリティが強化された関係で、
          アプリがインストールされていない場合数秒後に遷移することが
          できなくなってしまったため、インストールボタンを表示 -->
          <p v-show="isIOS" class="text-center">
            <a
              href="https://geo.itunes.apple.com/us/app/epson-creative-print/id685791389?pt=280580&ct=gallery&mt=8"
              class="btn btn-default btn-lg"
              role="button"
              target="_blank"
              v-on:click="trackGaEvent('install_creative_iOS')"
            >
              <LabelFunMessage fcontId="0" msgkey="32" />&nbsp;&raquo;
            </a>
          </p>
        </div>
      </div>
    </collapse>
  </div>
</template>

<script>
import { LAUNCH_TYPE, CONTENTS_INFO, CONTENT_TYPE, PAPER_SIZE, PAPER_TYPE } from "@/common/contentsinfo";
import { mapState, mapGetters } from "vuex";
import LabelFunMessage from "./LabelFunMessage";
import AppCompatiblePrinters from "./AppCompatiblePrinters";
import { Collapse } from "uiv";

const NOT_DEFINE_FCONT_ID = "designpaper_samplepage"

export default {
  name: "PrintMenuCreativePrint",
  components: {
    LabelFunMessage,
    AppCompatiblePrinters,
    Collapse
  },
  props: {
    launchType: String, // select, print
    contentType: String, // designPaper, photoLayout, nenga など
    categoryId: String, // CreativePrintでは未使用
    designId: String, // designPaperの場合：xx-xx
    mediaSizeId: String,
    mediaTypeId: String, // CreativePrintでは未使用
    fcontId: String,
  },
  data() {
    return {
      isMenuOpened: false,
      app_root: process.env.VUE_APP_ROOT
    };
  },
  computed: {
    ...mapGetters(["isJpTemplate","isWwTemplate"]),
    ...mapState(["os"]),
    isIOS: function () {
      return this.os == "ios";
    },
    isMobile: function () {
      return this.os == "ios" || this.os == "ard";
    },
    isSupport: function () {
      if (this.isMobile) {
        switch (this.contentType) {
          case CONTENT_TYPE.photobook: 
            return this.isJpTemplate;
          case CONTENT_TYPE.designpaper:
          case CONTENT_TYPE.photoLayout:
          case CONTENT_TYPE.freeLayout:
          case CONTENT_TYPE.album:
          case CONTENT_TYPE.greetingCards:
          case CONTENT_TYPE.creativeTop:
            return true;
          case CONTENT_TYPE.nenga:
          case CONTENT_TYPE.postcard:
          case CONTENT_TYPE.designpaperPremiumCollection:
          case CONTENT_TYPE.createplusContents:
          default:
            return false;
        }
      }
      return false;
    },
    // TODO: 今後他アプリと同じTypeIdを送っても動作として問題ないか確認する
    appPaperTypeId: function () {
      if (this.mediaSizeId == PAPER_SIZE.Postcard ) {
        return PAPER_TYPE.hagakiInkjet
      }
      return PAPER_TYPE.plain
    },
    // Creativeではお客様に柄を選んでいただく場合も一例として記事内で使用している柄を選択して起動しているため
    appDefaultDesignId: function () {
      let designList = CONTENTS_INFO[this.fcontId].design_id_list
      if (designList == undefined || designList.length == 0) {
        return "01-01"
      }else {
        return designList[0]
      }
    },
    selectOpenUrl: function () {
      switch (this.contentType) {
        case CONTENT_TYPE.designpaper: {
          const applink = {
            "apptype":"print",
            "design_id":this.appDefaultDesignId,
            "angle":"0",
            "media_type":this.appPaperTypeId,
            "media_size":this.mediaSizeId
          }
          return this.printCreativePrintUrl(this.os, applink, this.articleId);
        }
        case CONTENT_TYPE.photoLayout:
        case CONTENT_TYPE.photobook:
        case CONTENT_TYPE.album:
        case CONTENT_TYPE.greetingCards:
        case CONTENT_TYPE.freeLayout:
        case CONTENT_TYPE.creativeTop: {
          return this.launchCreativePrintUrl(this.os, this.articleId);
        }
        case CONTENT_TYPE.nenga:
        case CONTENT_TYPE.postcard:
        case CONTENT_TYPE.designpaperPremiumCollection:
        default:
          return "";
      }
    },
    printOpenUrl: function () {
      const applink = {
        "apptype":"print",
        "design_id":this.designId,
        "angle":"0",
        "media_type":this.appPaperTypeId,
        "media_size":this.mediaSizeId
      }
      return this.printCreativePrintUrl(this.os, applink, this.articleId);
    },
    articleId: function () {
      if (this.fcontId == undefined) {
        return NOT_DEFINE_FCONT_ID
      }else {
        return `fcont_${this.fcontId}_${this.launchType}`;
      }
    },
    defaultMenuOpened: function () {
      switch (this.contentType) {
        case CONTENT_TYPE.photoLayout:
        case CONTENT_TYPE.freeLayout:
        case CONTENT_TYPE.photobook:
        case CONTENT_TYPE.album:
        case CONTENT_TYPE.greetingCards:
        case CONTENT_TYPE.designpaper:
        case CONTENT_TYPE.creativeTop:
          return true;
        case CONTENT_TYPE.nenga:
        case CONTENT_TYPE.postcard:
        case CONTENT_TYPE.designpaperPremiumCollection:
        default:
          return false;
      }
    },
    isA4MattPaper: function () {
      return this.mediaSizeId == PAPER_SIZE.A4 && this.mediaTypeId == PAPER_TYPE.matte
    },
    isLocalChina: function () {
      return window.location.host == "support.epson.com.cn"
    }
  },
  mounted: function () {
    this.isMenuOpened = this.defaultMenuOpened
  },
  methods: {
    trackGaEvent: function (action) {
      if (action == "install_creative_iOS") {
        this.trackGa4AppDownloadEvent()
      }else {
        this.trackGa4GoAppEvent()
      }
    },
    trackGaEventPrintButton: function () {
      this.trackGaEvent("printbutton_" + this.launchType + "_creative")
    },
    trackGa4AppDownloadEvent: function() {
      this.$gtag.event("app_download", {
        "app_name": "Creative Print",
        "location_id": "printButton",
        "article_no": this.fcontId,
        "site_id": "gallery"
      })
    },
    trackGa4GoAppEvent: function() {
      this.$gtag.event("go_app", {
        "app_name": "Creative Print",
        "article_no": this.fcontId,
        "print_type": this.launchType,
        "design_id": this.designId,
        "site_id": "gallery"
      })
    },
    launchApp: function () {
      this.trackGaEventPrintButton()
      
      let openUrl = "";
      switch (this.launchType) {
        case LAUNCH_TYPE.select:
          openUrl = this.selectOpenUrl;
          break;
        case LAUNCH_TYPE.print:
          openUrl = this.printOpenUrl;
          break;
        default:
          openUrl = this.selectOpenUrl;
      }
      window.location = openUrl;
      this.$log.debug("url", openUrl);
    },
    launchCreativePrintUrl: function (clientDevice, pinfOption) {
      //Creative Print  アプリを起動
      switch (clientDevice) {
        case "ios": {
          const IOS_URLSCHEME = "com.epson.mobilephone.creative";
          const BASE_APPOPTION = "launch";
          const query = [
            {
              key: "source_app",
              value: `Epson.sn_${pinfOption}`,
            },
          ];
          return this.openIOSURL(IOS_URLSCHEME, BASE_APPOPTION, query);
        }
        case "ard": {
          const ANDROID_URLSCHEME = "com.epson.mobilephone.creative";
          const ANDROID_PACKAGE = "com.epson.mobilephone.creative";
          const query = [
            {
              key: "S.source_app",
              value: `Epson.sn_${pinfOption}`,
            },
          ];
          return this.openAndroidURL(ANDROID_URLSCHEME, ANDROID_PACKAGE, query);
        }
      }
    },
    printCreativePrintUrl: function (clientDevice, applink, pinfOption) {
      switch (clientDevice) {
        case "ios": {
          const IOS_URLSCHEME = "com.epson.mobilephone.creative.designpaper.v1";
          const BASE_APPOPTION = "print";
          const query = [
            {
              key: "design_id",
              value: applink.design_id,
            },
            {
              key: "angle",
              value: applink.angle,
            },
            {
              key: "media_type",
              value: applink.media_type,
            },
            {
              key: "media_size",
              value: applink.media_size,
            },
            {
              key: "source_app",
              value: `Epson.sn_${pinfOption}`,
            },
          ];
          return this.openIOSURL(IOS_URLSCHEME, BASE_APPOPTION, query);
        }
        case "ard": {
          const ANDROID_URLSCHEME =
            "com.epson.mobilephone.creative.designpaper.v1";
          const ANDROID_PACKAGE = "com.epson.mobilephone.creative"; //S.source_app=Epson.sn.test1";

          const query = [
            {
              key: "S.design_id",
              value: applink.design_id,
            },
            {
              key: "i.angle",
              value: applink.angle,
            },
            {
              key: "i.media_type",
              value: applink.media_type,
            },
            {
              key: "i.media_size",
              value: applink.media_size,
            },
            {
              key: "S.source_app",
              value: `Epson.sn_${pinfOption}`,
            },
          ];
          return this.openAndroidURL(ANDROID_URLSCHEME, ANDROID_PACKAGE, query);
        }
      }
    },
    openIOSURL: function (scheme, appoption, query) {
      const IOSquery = query.map((q) => `${q.key}=${q.value}`).join("&");
      const IOS_OPENURL = `${scheme}:///${appoption}?${IOSquery}`;
      return IOS_OPENURL
    },
    openAndroidURL: function (scheme, andpackage, query) {
      const Androidquery = query.map((q) => `${q.key}=${q.value}`).join(";");
      const ANDROID_OPENURL = `intent://#Intent;scheme=${scheme};package=${andpackage};${Androidquery};end;`;
      return ANDROID_OPENURL
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


.app_info {
  text-align: center;
  margin: 20px auto;
}

.app_info img {
  max-width: 100px;
}

.app_title {
  margin-top: 20px;
  margin-left: 10px;
}

/* スマホサイズのみ適用 */
@media screen and (max-width: 991px) {
}
</style>